// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';

const Fallback = (): React$MixedElement => (
  <>
    <div className="map-is__placeholder page__section page__section--breaker map-is__breaker t-subtle">
      <div className="map-is__breaker-inner">
        <div className="map-is__loader">
          <p className="map-is__loader-text">
            {t('Inhalte konnten nicht geladen werden.')}
          </p>
        </div>
      </div>
    </div>
  </>
);
export default Fallback;
